// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type UpdateObjectStatusMutationVariables = Types.Exact<{
  customFieldDefinition: Types.CustomFieldDefinitionModelInput;
}>;

export type UpdateObjectStatusMutation = { updateCustomFieldDefinition: { name?: string | null; uid: string } };

export const UpdateObjectStatusDocument = gql`
    mutation UpdateObjectStatus($customFieldDefinition: CustomFieldDefinitionModelInput!) {
  updateCustomFieldDefinition(customFieldDefinition: $customFieldDefinition) {
    name
    uid
  }
}
    ` as unknown as DocumentNode<UpdateObjectStatusMutation, UpdateObjectStatusMutationVariables>;
